import { useQuery } from "@tanstack/react-query"
import { Study } from "../types/types"
import { apiFetch, apiFetchProtected } from "../utils/api"

const fecthStudyHashed = async (hash: string): Promise<Study> =>
  apiFetch<Study>("/filter/studies/" + hash, {})

const fecthStudy = async (hash: string): Promise<Study> =>
  apiFetchProtected<Study>("/studies/" + hash, {})

export const useStudyHashedQuery = <TData = Study>(
  hash: string | undefined | null,
  select?: (data: Study) => TData
) => {
  return useQuery({
    queryKey: ["study", hash],
    queryFn: () => fecthStudyHashed(hash?.toString() ?? ""),
    enabled: !!hash,
    select
  })
}

export const useStudyQuery = <TData = Study>(
  id: string | undefined | null,
  select?: (data: Study) => TData
) => {
  return useQuery({
    queryKey: ["study", id],
    queryFn: () => fecthStudy(id?.toString() ?? ""),
    enabled: !!id,
    select
  })
}
